/** Shared group chat avatar — multi-person icon with configurable color and size */

interface GroupAvatarProps {
  color?: string;
  size?: number;
}

export function GroupAvatar({ color = '#5a6a2a', size = 44 }: GroupAvatarProps) {
  const iconSize = Math.round(size * 0.59);
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', background: color,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0,
    }}>
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="8" r="3.2" fill="#f1ecdf" opacity="0.95"/>
        <path d="M6.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="#f1ecdf" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.95"/>
        <circle cx="5.5" cy="9.5" r="2.2" fill="#f1ecdf" opacity="0.55"/>
        <path d="M1.5 17.5c0-2.2 1.8-3.5 4-3.5" stroke="#f1ecdf" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.55"/>
        <circle cx="18.5" cy="9.5" r="2.2" fill="#f1ecdf" opacity="0.55"/>
        <path d="M22.5 17.5c0-2.2-1.8-3.5-4-3.5" stroke="#f1ecdf" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.55"/>
      </svg>
    </div>
  );
}
